var e = /* @__PURE__ */ ((r) => (r.danger = "danger", r.blue = "blue", r))(e || {});
export {
  e as NeutralTypeEnum
};
